import { connect } from "react-redux";
import LanguageSelectButton from "./LanguageSelectButton";
import { userChangeLanguage } from "../../redux/operations/userOperations";

function mapStateToProps(state) {
  return {
    currentLang: !!state.authReducer.lang ? state.authReducer.lang : "lang",
  };
}

function mapDispatchToProps(dispatch) {
  return {
    changeLanguage: (language) => dispatch(userChangeLanguage(language)),
  };
}

const connectedLanguageSelectButton = connect(
  mapStateToProps,
  mapDispatchToProps
)(LanguageSelectButton);

export default connectedLanguageSelectButton;
